import { type NativeStackHeaderItem } from 'expo-router'

type Args = {
  onPress: () => void
}

export default function closeButton({ onPress }: Args): NativeStackHeaderItem {
  return {
    type: 'button',
    label: '关闭',
    icon: {
      name: 'xmark',
      type: 'sfSymbol',
    },
    onPress,
  }
}
